// Login da área do afiliado: quem já tem a sessão da área vai direto ao painel.
// O link "Esqueci minha senha" dos emails (`?recuperar-senha=1`) fica no login,
// para o modal abrir mesmo com uma sessão antiga no navegador.
//
// Na primeira carga (hidratação) não redireciona, para não dar mismatch: ali quem
// decide é o onMounted de pages/[language]/afiliado/index.vue.
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server || useNuxtApp().isHydrating) return;

  if (afiliadoStore().token && !to.query["recuperar-senha"]) {
    return navigateTo({ name: "language-afiliado-painel", params: { language: to.params.language } });
  }
});
